var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.71,
    height: 18.595,
    viewBox: "0 0 17.71 18.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(0 -64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M136.653,419.985a3.324,3.324,0,0,1-3.321-3.321.664.664,0,1,1,1.328,0,1.992,1.992,0,1,0,3.985,0,.664.664,0,1,1,1.328,0A3.324,3.324,0,0,1,136.653,419.985Zm0,0",
    transform: "translate(-127.798 -337.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M16.16,79.939H1.55A1.55,1.55,0,0,1,.542,77.212a5.934,5.934,0,0,0,2.115-4.544V70.2a6.2,6.2,0,0,1,12.4,0v2.469a5.933,5.933,0,0,0,2.106,4.538,1.549,1.549,0,0,1-1,2.734ZM8.855,65.329a4.875,4.875,0,0,0-4.87,4.87v2.469A7.257,7.257,0,0,1,1.408,78.22a.22.22,0,0,0-.08.17.224.224,0,0,0,.221.221H16.16a.224.224,0,0,0,.221-.221.219.219,0,0,0-.078-.168,7.259,7.259,0,0,1-2.578-5.554V70.2a4.875,4.875,0,0,0-4.87-4.87Zm0,0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9259085415c25b0fbdd8335f036d0668.svg";
export { ForwardRef as ReactComponent };